import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance';

const INIT = { code:'', discountType:'percentage', discountValue:'', minPurchase:'', isActive:true };

const CouponManager = () => {
  const [coupons, setCoupons] = useState([]);
  const [form,    setForm]    = useState(INIT);
  const [msg,     setMsg]     = useState({ text:'', type:'' });

  const fetchCoupons = async () => {
    try {
      const res = await axiosInstance.get('/auth/admin/coupons');
      setCoupons(res.data.coupons || []);
    } catch { /* silent */ }
  };

  useEffect(() => { fetchCoupons(); }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await axiosInstance.post('/auth/admin/create-coupon', form);
      setMsg({ text: res.data.message || 'Coupon created', type:'success' });
      setForm(INIT);
      fetchCoupons();
    } catch (err) {
      setMsg({ text: err.response?.data?.message || 'Error creating coupon', type:'error' });
    }
  };

  const toggleStatus = async id => {
    try {
      await axiosInstance.put(`/auth/admin/coupon/${id}/toggle`);
      fetchCoupons();
    } catch (err) {
      setMsg({ text: err.response?.data?.message || 'Failed to update', type:'error' });
    }
  };

  const deleteCoupon = async id => {
    if (!window.confirm('Delete this coupon?')) return;
    try {
      await axiosInstance.delete(`/auth/admin/coupon/${id}`);
      fetchCoupons();
    } catch (err) {
      setMsg({ text: err.response?.data?.message || 'Failed to delete', type:'error' });
    }
  };

  return (
    <div className="coupon-page">
      <div className="ph"><div><h1>Coupons</h1><p>Create and manage discount coupons</p></div></div>

      {msg.text && (
        <div className={`alert alert-${msg.type === 'success' ? 'success' : 'error'}`} style={{ marginBottom:14 }}>
          {msg.text}
          <button className="alert-close" onClick={() => setMsg({ text:'', type:'' })}>✕</button>
        </div>
      )}

      {/* Form */}
      <div className="coupon-form-card">
        <div className="coupon-form-title">Create Coupon</div>
        <form onSubmit={handleSubmit}>
          <div className="coupon-form-grid">
            <div className="form-group">
              <label className="form-label">Coupon Code</label>
              <input className="form-control" name="code" value={form.code} onChange={handleChange} placeholder="e.g. SAVE20" required />
            </div>
            <div className="form-group">
              <label className="form-label">Discount Type</label>
              <select className="form-control" name="discountType" value={form.discountType} onChange={handleChange}>
                <option value="percentage">Percentage (%)</option>
                <option value="flat">Flat (₹)</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Discount Value</label>
              <input className="form-control" type="number" name="discountValue" value={form.discountValue} onChange={handleChange} placeholder="e.g. 20" required />
            </div>
            <div className="form-group">
              <label className="form-label">Min Purchase (optional)</label>
              <input className="form-control" type="number" name="minPurchase" value={form.minPurchase} onChange={handleChange} placeholder="e.g. 200" />
            </div>
          </div>
          <div className="coupon-form-actions">
            <label className="checkbox-row">
              <input type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} /> Active
            </label>
            <button type="submit" className="btn btn-primary btn-sm">Create Coupon</button>
          </div>
        </form>
      </div>

      {/* Table */}
      <div className="tbl-wrap">
        {coupons.length === 0 ? (
          <div className="empty-state"><i className="fas fa-tag" style={{ fontSize:32,color:'var(--t3)' }} /><p>No coupons yet</p></div>
        ) : (
          <table className="tbl">
            <thead>
              <tr><th>#</th><th>Code</th><th>Type</th><th>Value</th><th>Min Purchase</th><th>Status</th><th>Created</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {coupons.map((c, i) => (
                <tr key={c._id}>
                  <td className="col-num">{i+1}</td>
                  <td><strong>{c.code}</strong></td>
                  <td style={{ textTransform:'capitalize' }}>{c.discountType}</td>
                  <td>{c.discountType === 'percentage' ? `${c.discountValue}%` : `₹${c.discountValue}`}</td>
                  <td>{c.minPurchase ? `₹${c.minPurchase}` : '—'}</td>
                  <td>
                    <span className={c.isActive ? 'coupon-active' : 'coupon-inactive'}>
                      {c.isActive ? '● Active' : '○ Inactive'}
                    </span>
                  </td>
                  <td className="date-cell">{new Date(c.createdAt).toLocaleDateString('en-IN')}</td>
                  <td>
                    <div style={{ display:'flex', gap:6 }}>
                      <button className="btn btn-outline btn-sm" onClick={() => toggleStatus(c._id)}>
                        {c.isActive ? 'Deactivate' : 'Activate'}
                      </button>
                      <button className="btn btn-danger btn-sm" onClick={() => deleteCoupon(c._id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default CouponManager;
